// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zRMwzGBGjfcozD_lNLfD{align-items:center;gap:8px;padding-left:12px;display:flex}.BONt9suBg8MVbSVBvVW0{flex:1;align-items:center;gap:10px}.BONt9suBg8MVbSVBvVW0 input{height:24px;font-size:16px}.HNkLwvAPOPkxoBIgSqPD{flex-grow:1;padding:0 16px;display:flex;position:relative}.SB9gQl_1rp06gKMlavBt{justify-content:space-between;align-items:center;display:flex}.rnKi5CpGnT0ohArZj9E7{color:var(--yellow-100);border:1px solid var(--black-10);background:var(--yellow-20);border-radius:4px;padding:2px 4px;display:inline-flex}.MNE31iD2sgLzdz505f40{margin:0 16px 24px}.RiqD2U1LA7kRL1gjm20_{color:var(--content-brand-primary);text-decoration:none}.RiqD2U1LA7kRL1gjm20_:hover{color:var(--content-brand-secondary)}.ZQ5VFp0lv0BqPbQwbJht{width:137px;text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `zRMwzGBGjfcozD_lNLfD`,
	"headerSearch": `BONt9suBg8MVbSVBvVW0`,
	"table": `HNkLwvAPOPkxoBIgSqPD`,
	"menuTitle": `SB9gQl_1rp06gKMlavBt`,
	"menuTitleLabel": `rnKi5CpGnT0ohArZj9E7`,
	"guidelineAlert": `MNE31iD2sgLzdz505f40`,
	"guidelineLink": `RiqD2U1LA7kRL1gjm20_`,
	"helpButton": `ZQ5VFp0lv0BqPbQwbJht`
};
export default ___CSS_LOADER_EXPORT___;
